<template>
  <div class="forgot-password">
    <img src="@/assets/logo_all_blue.png" class="logo" />

    <div class="inputs">
      <transition name="fade">
        <el-alert
          v-if="sent"
          title="We have sent you a mail"
          class="some-alert"
          type="success">
        </el-alert>
      </transition>
    
      <dg-input type="text" v-model="formData.name" placeholder="Name" icon="user"/>
      <dg-input type="text" v-model="formData.email" placeholder="E-mail" icon="at"/>

      <el-button :loading="loading" type="primary" @click="sendMail" class="forgot-button" style="margin-bottom: 15px;">Go</el-button>
      <router-link to="signin" tag="button" class="el-button el-button--text signin-button">Remembered anyway? Sign in</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      formData: {
        name: '',
        email: ''
      },
      sent: false,
      loading: false,
      error: null
    }
  },
  methods: {
    async sendMail () {
      this.loading = true
      try {
        const response = await this.$http.post(this.$api.auth.forgot, this.formData)
        this.sent = true
      } catch (err) {
        this.sent = true
      }
      this.loading = false
    }
  },
  created () {
    if (this.$auth.isLoggedIn()) {
      this.$router.push((this.redirect && this.redirect.length > 0) ? this.redirect : '/dashboard/')
    }
  }
}
</script>

<style lang="scss" scoped>

  .forgot-password {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    @include breakpoint (xs) {
      max-height: 100vh;
    }
  }

  .logo {
    width: 160px;
    height: auto;
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .inputs {
    width: 300px;
    margin: 0 auto;
    margin-top: 50px;

    .dg-input {
      margin-bottom: 20px;
    }

    button {
      margin-top: 20px;
    }
  }


  .forgot-button, .signin-button {
    width: 100%;
    display: block;
  }

  .signin-button {
    font-size: 14px !important;
    margin-left: 0px;
  }

  .some-alert {
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/front/ForgotPassword.vue